/*********************************************************
 *                  Carrier vehicle edit Ctrl
 ********************************************************/


"use strict";

angular.module("manager")
	.controller("VehicleEditCtrl", [
		"$scope", "Utils", "$location", "VehicleService", "toastr", "editMode", "equipmentList", "selectedVehicle",
		function ($scope, Utils, $location, VehicleService, toastr, editMode, equipmentList, selectedVehicle) {

		/**
		 * INIT
		 */
		$scope.data = {
			selectedVehicle: selectedVehicle.data,
			availableEquipmentList: equipmentList.data,
			selectedEquipmentList: [],
			categoryList: ["BUS", "CAR", "MINIBUS"],
			editMode: editMode
		};

		if (editMode) {
			// Cas d'édition d'un vehicule.
			$scope.data.availableEquipmentList.forEach(function (equipment) {
				equipment.selected = $scope.data.selectedVehicle.vehicleEquipmentList.map(function (e) {return e.name;}).includes(equipment.name);
			});

			$scope.data.selectedVehicle.circulationDate = Utils.getJSDateFromLocale($scope.data.selectedVehicle.circulationDate);
		} else {
			// Cas d'ajout un vehicule.
			$scope.data.selectedEquipmentList = equipmentList;
			$scope.data.availableEquipmentList.forEach(function(equipment) { return equipment.selected = false; });
		}

		/**
		 * Valide l'ajout d'un véhicule
		 * @param vehicle
		 */
		$scope.addVehicle = function (vehicle) {
			VehicleService.addVehicle(vehicle)
				.then(() => {
					toastr.success("Vehicule ajouté.");
					$location.url("/manager/vehicles");
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "Erreur lors de l'ajout du véhicule."));
				});
		};

		/**
		 * Valide la modification d'un véhicule
		 * @param vehicle
		 */
		$scope.editVehicle = function(vehicle) {
			VehicleService.editVehicle(vehicle)
				.then(() => {
					toastr.success("Vehicule modifié.");
					$location.url("/manager/vehicles");
				})
				.catch((error) => {
					toastr.error(Utils.makeErrorMessage(error.data, "Erreur lors de la modification du véhicule."));
				});
		};

		/**
		 * Gestion de la cohérence entre la liste des équipements dans l'objet selectedVehicle et l'affichage
		 * @param equipment
		 */
		$scope.equipmentListChange = function (equipment) {
			if ($scope.data.selectedVehicle.vehicleEquipmentList == null) {
				$scope.data.selectedVehicle.vehicleEquipmentList = [];
			}

			var equipmentIndex = $scope.data.selectedVehicle.vehicleEquipmentList.findIndex(function (e) { return e.id === equipment.id; });
			// Check if id already added or not
			if (equipmentIndex === -1) {
				$scope.data.selectedVehicle.vehicleEquipmentList.push({id: equipment.id, name: equipment.name});
			} else { // Delete if already in it
				$scope.data.selectedVehicle.vehicleEquipmentList.splice(equipmentIndex, 1);
			}
		};
	}]
	);